export default "__VITE_ASSET__8Jay9nMS__"